<template>
  <div :class="{ 'panel-admin-body': !embeddedInRoadmap }">
    <div v-if="!embeddedInRoadmap" class="d-flex title">
      <div class="pb-1 button-center">
        <modal-link modal-id="How to Use" :content-list="pageContent" :image-size="'large'"></modal-link>{{ title }}
        <smart-center-link page="Predictive" location="Header" />
      </div>
      <div class="ml-auto">
        <i v-show="this.$root.getShowMenuIcon() && this.$root.getShowHeaderMenu()" class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
        <i v-show="this.$root.getShowMenuIcon() && !this.$root.getShowHeaderMenu()" class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
      </div>
    </div>
    <saved-card-menu v-if="!embeddedInRoadmap" :entry-client-object="clientObject" :original-saved-cards="clientChartsBySurvey" set-type="survey" view-type="menu"></saved-card-menu>
    <div class="predictive-analytics">
      <chart-criteria-predictive ref="chartCriteria" />
      <div v-if="display" class="container">
        <div class="form-row no-gutters">
          <div v-if="embeddedInRoadmap" class="form-group roadmap-view-navigation mb-0">
            <label class="control-label pt-1 pr-1 my-auto">Views</label>
            <div class="d-flex justify-content-left flex-wrap">
              <chart-type-card
                v-for="(option, idxViewNavigationOption) in viewNavigationOptions"
                :chart-type="option.value"
                :display-name="option.name"
                :current-display-type="currentRoadmapView"
                :disabled="option.disabled === true"
                @select="$emit('select-roadmap-view', $event)"
                v-bind:key="idxViewNavigationOption"
              ></chart-type-card>
            </div>
          </div>
          <div class="d-flex btn-group-horizontal align-items-center pl-2 pt-3 pb-2" role="group">
            <button type="submit" class="btn btn-primary mr-3" @click="getDetailedPredictiveAnalytics" :disabled="disableGenerate">
              <span>Analyze</span>
              <span v-show="this.$root.getLoading()" class="spinner-border spinner-border-sm"></span>
            </button>
            <button type="submit" class="btn btn-primary" @click="resetChartCriteria">Reset</button>
            <button v-show="display && getDisplayView()" id="save_chart" class="btn btn-primary ml-3 mr-3" type="button" @click="$modal.show('save-chart-confirmation')" :disabled="disableSaveAsCardButton">Save as Card</button>
          </div>
          <div v-show="display && getDisplayView()" class="show-hide-chart-criteria-results mt-3">
            <!--
            <modal-link modal-id="Show Chart Criteria Selections" :content-list="pageContent"></modal-link>
            -->
            <a href="#" v-show="!displayChartCriteriaResults" @click.prevent="toggleChartCriteriaResults">Show Chart Criteria Selections<i class="fa fa-chevron-down ml-1"></i></a>
            <a href="#" v-show="displayChartCriteriaResults" @click.prevent="toggleChartCriteriaResults">Hide Chart Criteria Selections<i class="fa fa-chevron-up ml-1"></i></a>
          </div>
        </div>
      </div>
      <div v-show="disableGenerate" class="row no-gutters pt-2 pb-2">
        <div>
          You cannot generate a profile unless you create at least one metric. Click here
          <router-link :to="{ name: 'metric-list' }">Respondent->Metrics</router-link>
          to add a metric
        </div>
      </div>
      <chart-criteria-results
        ref="chartCriteriaResults"
        :is-predictive-analytics="true"
        v-show="displayChartCriteriaResults"
        v-bind:criteria-results-list="criteriaResultsList"
        v-bind:criteria-results-company-list="criteriaResultsCompanyList"
      ></chart-criteria-results>
      <div id="predictive-analytics-chart" class="col-12 chart-data" v-show="displayChartOnly && getDisplayView()">
        <profile-chart-header
            :title="chartTitle + ' | ' + titleSuffix"
            :display="true"
            :input-display-number-of-responses="eChartCriteria.displayNumberOfResponses"
            :input-show-tooltip="eChartCriteria.showTooltip"            
            :display-show-respondents="false"
            :display-download-comments="false"
            :display-show-tooltip="false"
            @set-display-number-of-responses="setDisplayNumberOfResponses"
        />
        <div class="row">
          <predictive-analytics-chart ref="eChart"
              :e-chart-mini-id="'predictive-analytics-e-chart-mini'"
              :e-chart-id="'predictive-analytics-e-chart'"
              :input-report-type-name="'Chart - Impact'"
              :modal-id="'predictive-analytics-chart'"
              :is-saved-card="this.clientChart.clientChartId != 0" 
              :input-client-chart="this.clientChart"
              @save-table="saveProfileDataTable"
              @save-criteria="buildClientChartForPredictiveAnalytics"/>        
          <div class="col-2">
            <div class="float-right">
              <predictive-analytics-chart-buttons ref="chartButtons" 
                  :input-show-labels="eChartCriteria.showLabels"
                  :input-show-tooltip="eChartCriteria.showTooltip"
                  @set-show-labels="setShowLabels"
                  @set-show-tooltip="setShowTooltip"
              />
              </div>
          </div> 
        </div>  
      </div>  
      <div v-show="isGenerateReportRunning() || (!displayChartOnly && getDisplayView())" id="analytics-contributions-container" class="predictive-analytics-echart">
        <div v-show="isGenerateReportRunning() || (!displayChartOnly && getDisplayView())" class="contribution  w-100"
            v-for="(contributionChart, idxContributionChart) in this.contributionChartList"
            v-bind:key="idxContributionChart">
                    <predictive-analytics-contribution-chart 
                      :is-saved-card="clientChart.clientChartId != 0" 
                      :contribution-chart="contributionChart" 
                      v-if="getDisplayView()"/>

        </div>
      </div>
      <div v-show="!displayChartOnly && getDisplayView()" id="analytics-title-and-chart" class="title-and-chart d-flex pt-3">
        <div v-show="!displayChartOnly && getDisplayView()" id="analytics-data-container" :class="isInsiderUser ? 'hide-table-data' : ''">
          <div v-show="isInsiderUser" class="overlay">
            <img class="overlay-inner" v-show="isInsiderUser" src="../../assets/img/overlap.png"  style="width: 250px"/>
          </div>
          <table v-if="isGenerateReportRunning() || (!displayChartOnly && getDisplayView())" :id="predictiveAnalyticsTable.id" style="display: none" class="table display wrap row-border table-hover" cellspacing="0" width="auto">
            <thead>
              <tr>
                <th
                  v-for="(baseDataHeader, idxBaseDataHeader) in this.predictiveAnalyticsData.tableHeader"
                  v-bind:key="idxBaseDataHeader"
                  v-bind:class="[baseDataHeader.hasOwnProperty('headerClass') ? baseDataHeader.headerClass : 'predictive-column']"
                >
                  <span v-html="baseDataHeader.data"></span>
                </th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
      </div>
      <div v-show="getDisplayView()" id="metric-trends-title-and-chart" class="title-and-chart d-flex pt-3">
          <div v-show="getDisplayView()" id="metric-trends-data-container" :class="isInsiderUser ? 'hide-table-data' : ''">
            <div v-show="isInsiderUser" class="overlay">
              <img class="overlay-inner" v-show="isInsiderUser" src="../../assets/img/overlap.png"  style="width: 250px"/>
            </div>
            <table v-if="getDisplayView()" :id="metricsTable.id" style="display: none" class="table display nowrap row-border table-hover" cellspacing="0" width="auto" height="80px">
              <thead>
                <tr>
                  <th
                    v-for="(baseDataHeader, idxBaseDataHeader) in this.metricsData.tableHeader"
                    v-bind:key="idxBaseDataHeader"
                    v-bind:class="[baseDataHeader.hasOwnProperty('headerClass') ? baseDataHeader.headerClass : 'predictive-column']"
                  >
                    <span>{{ baseDataHeader.data }}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(returnMetric, idxReturnMetrics) in this.returnMetricTableRows()"
                  v-bind:key="idxReturnMetrics"
                >
                  <td
                      v-for="(sales, idxSales) in returnMetric"
                      v-bind:key="idxSales"
                      v-bind:class="[sales.hasOwnProperty('dataClass') ? sales.dataClass : 'predictive-column']"
                    >
                      <span>{{ sales.data }}</span>
                    </td>
                </tr>
              </tbody>
            </table>
        </div>
      </div>
      <div v-show="!displayChartOnly && getDisplayView()" id="profile-trends-title-and-chart" class="title-and-chart d-flex pt-3">
        <div v-show="!displayChartOnly && getDisplayView()" class="w-100 mt-5">
          <div v-show="!displayChartOnly && getDisplayView()" id="profile-trends-data-container" :class="isInsiderUser ? 'hide-table-data' : ''">
            <div v-show="isInsiderUser" class="overlay">
              <img class="overlay-inner" v-show="isInsiderUser" src="../../assets/img/overlap.png"  style="width: 250px"/>
            </div>
            <table v-if="isGenerateReportRunning() || (!displayChartOnly && getDisplayView())" :id="needsTable.id" style="display: none" class="table display wrap row-border table-hover" cellspacing="0" width="auto">
              <thead>
                <tr>
                  <th></th>
                  <th
                    v-for="(tableHeader, idxTableHeader) in this.needsData.tableHeader"
                    v-bind:key="idxTableHeader"
                    v-bind:class="[tableHeader.hasOwnProperty('headerClass') ? tableHeader.headerClass : 'predictive-column']"
                  >
                    <span>
                      {{ tableHeader.data }}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, idxRows) in this.needsData.rowsMap.rows" v-bind:key="idxRows">
                  <td v-if="idxRows == 0">1</td>
                  <td v-if="idxRows != 0">0</td>
                  <td v-for="(needRow, idxNeedsRow) in row" v-bind:key="idxNeedsRow" v-bind:class="[needRow.hasOwnProperty('dataClass') ? needRow.dataClass : 'predictive-column']">
                    <span>{{ needRow.data }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <vue-modal ref="save-chart-confirmation" name="save-chart-confirmation" :width="350" :height="200">
        <save-chart button-label="Save as Card" :chart-title="this.chart.title" :initial-client-chart="this.clientChart" @save="updateClientCharts" @closeModal="closeModal('save-chart-confirmation')"></save-chart>
      </vue-modal>
    </div>
    
    <insights
      ref="insightsChartImpact"
      :modal-name="'predictive-analytics-chart'"
      :report-page-type-name="'Chart - Impact'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="saveClientChart"
    />

    <insights
      ref="insightsMetricsTable"
      :modal-name="'metrics-table'"
      :report-page-type-name="'Metric Trends'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="saveClientChart"
    />
    <insights
      ref="insightsPredictiveAnalyticsTable"
      :modal-name="'predictive-analytics-table'"
      :report-page-type-name="'Predictive Analytics'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="saveClientChart"
    />
    <insights
      ref="insightsProfileTable"
      :modal-name="'needs-table'"
      :report-page-type-name="'Profile Trends'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="saveClientChart"
    />
    <counts-by-location ref="countsByLocation" :period="String(endPeriod)"/>
  </div>
</template>
<script>
import $ from "jquery";
import { reactive, toRaw } from 'vue'
import ChartCriteriaPredictive from "../../components/chart/ChartCriteriaPredictive.vue";
import ChartTypeCard from "../../components/chart/ChartTypeCard.vue";
import PredictiveAnalyticsService from "../../services/echarts/predictive.analytics.service";
import WordCloudService from "../../services/word.cloud.service";
import ReportService from "../../services/report.service";
import PrintAndCopyService from "../../services/print.and.copy.service";
import ClientCompetitorService from "../../services/client.competitor.service";
import TableService from "../../services/table.service";
import ChartService from "../../services/chart.service";
import ClientService from "../../services/client.service";
import EChartsService from "../../services/echarts.service";
import UserService from "../../services/user.service";
import SurveyService from "../../services/survey.service";
import AdminService from "../../services/admin.service";
import MetricsService from "../../services/metrics.service";
import ContentService from "../../services/content.service";
import GoogleService from "../../services/google.service";
import ContentMixins from "../../mixins/ContentMixins.vue";
import ChartCompanyMixins from "../../mixins/ChartCompanyMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import ChartCriteriaMixins from "../../mixins/ChartCriteriaMixins.vue";
import ChartCriteriaResults from "../../components/chart/ChartCriteriaResults.vue";
import SaveChart from "../../components/chart/SaveChart.vue";
import CountsByLocation from "../../modals/CountsByLocation.vue";
import PredictiveAnalyticsContributionChart from "../../views/echarts/PredictiveAnalyticsContributionChart.vue";
import ProfileChartHeader from "../../components/echarts/ProfileChartHeader.vue";
import PredictiveAnalyticsChart from "../../views/echarts/PredictiveAnalyticsChart.vue";
import PredictiveAnalyticsChartButtons from "../../components/echarts/PredictiveAnalyticsChartButtons.vue";
//import ProfileChartHeader from "../../components/echarts/ProfileChartHeader.vue";

export default {
  name: "PredictiveAnalytics",
  mixins: [ContentMixins, ChartCompanyMixins, DataTableMixins, ChartCriteriaMixins],
  components: {
    ChartCriteriaResults,
    ChartCriteriaPredictive,
    ChartTypeCard,
    SaveChart,
    CountsByLocation,
    PredictiveAnalyticsContributionChart,
    PredictiveAnalyticsChart,
    PredictiveAnalyticsChartButtons,
    ProfileChartHeader
  },
  props: {
    embeddedInRoadmap: {
      type: Boolean,
      default: false
    },
    viewNavigationOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    currentRoadmapView: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      companyId: "0",  // Roadrunner 40735, Premium 40736
      company_options: [],
      defaultClientChartName: "",
      display: false,
      disableGenerate: false,
      displaySecondAxisOnTable: false,
      pageNumber: 6,
      metricGroupId: "0",
      secondaryMetricGroupId: "-1",
      baseMetricGroupId: 0,
      correlationTypeId: 1,
      includePartialResponses: "Y",
      startPeriod: 0,
      endPeriod: 0,
      basePeriod: 0,
      period_options: [],
      metric_options: [],
      useMetricGrowth: false,
      useMetricGrowthForSecondary: false,
      chartTitle: "Predictive Analytics",
      title: "Predictive",
      metricsTableContainerId: "metrics-table",
      analyticsTableContainerId: "predictive-analytics-table", 
      profileTableContainerId:"needs-table",
      chart: {
        title: "Predictive",
        typeName: "predictive-analytics"
      },
      metricsData: {},
      predictiveAnalyticsData: {
        rowsMap: {}
      },
      needsData: {
        rowsMap: {}
      },
      primaryMetric:{
        metricGroupId: 0,
        useMetricGrowth: false,
        isPrimary: true,
        isSecondary: false,
        isAdditional: false,
      },
      secondaryMetric:{
        metricGroupId: 0,
        useMetricGrowth: false,
        isPrimary: false,
        isSecondary: true,
        isAdditional: false,
      },
      positiveClass: "text-success",
      negativeClass: "text-danger",
      baseClass: "predictive-column",
      notActiveClass: "",
      metricsTable: MetricsService.getPredictiveTableAttributes("metrics-table"),
      predictiveAnalyticsTable: MetricsService.getPredictiveTableAttributes("predictive-analytics-table"),
      needsTable: MetricsService.getPredictiveTableAttributes("needs-table"),
      snapModalContent: PrintAndCopyService.getSnapMessage(),
      contributionChartList: [],
      eChartCriteria: this.getDefaultEChartCriteria(),
      selectedAdditionalSecondaryMetrics: [],
      titleSuffix: "",
    };
  },
  methods: {
    setDefaultClientChartName() {
      this.defaultClientChartName = "";
      let primaryAxisName = "";  
      let currenMetricGroup = this.metric_options.find(metricGroup => Number(metricGroup.value) == Number(this.metricGroupId));
      if (typeof currenMetricGroup != "undefined") {
        this.defaultClientChartName = currenMetricGroup.name;
      }
      let secondaryAxisName = "";
      let currenSecondaryMetricGroup = this.secondary_metric_options.find(metricGroup => Number(metricGroup.value) == Number(this.secondaryMetricGroupId));
      if (typeof currenSecondaryMetricGroup != "undefined") {
        secondaryAxisName = currenSecondaryMetricGroup.name;
        this.defaultClientChartName +=  " vs ";
        this.defaultClientChartName += secondaryAxisName;
      }
      // add the additional metrics
      for (let i = 0; i < this.selectedAdditionalSecondaryMetrics.length; i++) {
        let metric = this.selectedAdditionalSecondaryMetrics[i];
        this.defaultClientChartName += " vs ";
        this.defaultClientChartName += metric.name;
      }
    },
    closeModal(name) {
      if(this.$refs[name] != null) {
        this.$refs[name].visible = false;
      }
    },
    async snapChart(displayLegend, snapContainerId) {
      PrintAndCopyService.initializeSnapChart(displayLegend, snapContainerId, this); 
    },
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Metric Trends") {
        this.$refs.insightsMetricsTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.reportPagesList);
        this.$refs.insightsMetricsTable.initializeInsights(this.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Predictive Analytics") {
        this.$refs.insightsPredictiveAnalyticsTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.reportPagesList);
        this.$refs.insightsPredictiveAnalyticsTable.initializeInsights(this.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Profile Trends") {
        this.$refs.insightsProfileTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.reportPagesList);
        this.$refs.insightsProfileTable.initializeInsights(this.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Chart - Impact") {
        this.$refs.insightsChartImpact.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.reportPagesList);
        this.$refs.insightsChartImpact.initializeInsights(this.clientChart);
        this.$modal.show(insightModalId);
      }
    },
    clearMetricsTable(event, tableType = 0) {
      if (typeof event != "undefined") {
        let newValue = event.target.value;
        if (typeof this.metricsTable.dataTable != "undefined" && this.metricGroupId != this.secondaryMetricGroupId) {
          this.metricsTable.dataTable.clear();
        } 
        if (tableType == 2 && this.metricGroupId == newValue){
          this.secondaryMetricGroupId = -1;
        } else if (tableType == 1 && this.secondaryMetricGroupId == newValue){
          this.secondaryMetricGroupId = -1;
        } 
        if (newValue != -1) {
          this.removeAdditionalSecondaryMetricByValue(newValue);
        } else {
          for (let i = 0; i < this.selectedAdditionalSecondaryMetrics.length; i++) {
            let metric = this.selectedAdditionalSecondaryMetrics[i];
            this.removeAdditionalSecondaryMetric(metric);            
          }
          this.selectedAdditionalSecondaryMetrics = [];
        }
        
        
      }
    },
    clearTable() {
      this.clearMetricsTable();
      if (typeof this.predictiveAnalyticsTable.dataTable != "undefined") {
        this.predictiveAnalyticsTable.dataTable.destroy();
        this.predictiveAnalyticsData = {};
        this.predictiveAnalyticsData.rowsMap = {};
      }         
      if (typeof this.needsTable.dataTable != "undefined") {
        this.needsTable.dataTable.destroy();
        this.needsData = {};
        this.needsData.rowsMap = {};
      }       
      this.setDisplayView(false);
    },
    resetDefaultMetricGroupId() {
      // if the primary_metric_options is not empty then set the metricGroupId to the first element
      if (this.primary_metric_options.length > 0) {
        this.metricGroupId = this.primary_metric_options[0].value;
      } else {
        this.metricGroupId = 0;
      }
      this.baseMetricGroupId = this.metricGroupId;
    },
    resetChartCriteria: function(resetAutoGenerateChartRun = true) {
      this.companyId = "0";
      this.resetDefaultMetricGroupId()
      this.resetOption = !this.resetOption;
      this.startPeriod = this.basePeriod;
      this.endPeriod = this.basePeriod;
      this.metricGroupId = this.baseMetricGroupId;
      this.secondaryMetricGroupId = "-1";
      for (let i = 0; i < this.selectedAdditionalSecondaryMetrics.length; i++) {
        let itemToRemove = this.selectedAdditionalSecondaryMetrics[i];
        this.removeAdditionalSecondaryMetric(itemToRemove);
      }
      this.selectedAdditionalSecondaryMetrics = [];
      this.surveyGroup = "";
      this.includePartialResponses = "Y";
      if (resetAutoGenerateChartRun == true){
        this.autoGenerateChartRun = false;
      }
      this.surveyLocation = [];
      this.words = [];
      this.resetCriteriaResults();
      GoogleService.logResetCriteria(this.chart.title, "", this.survey.name, this);
      this.eChartCriteria = this.getDefaultEChartCriteria();
    },
    toggleChartCriteriaResults() {
      this.displayChartCriteriaResults = !this.displayChartCriteriaResults;
    },
    processAutoGenerateChart() {
      if (this.autoGenerateChartRun) {
        this.hideChartCriteriaSections();
        this.displayChartCriteriaResults = false;
        if (typeof this.clientChart != "undefined") {
          if (typeof this.clientChart.criteria != "undefined" && this.clientChart.criteria != "") {
            let criteriaParameters = this.clientChart.criteria.split("&");
            for (let criteriaIndex = 0; criteriaIndex < criteriaParameters.length; criteriaIndex++) {
              let criteria = criteriaParameters[criteriaIndex];
              this.processSavedChartCriteria(criteria);
            }
          }
          this.metricGroupId = this.generateMetricGroupId(this.metricGroupId, this.useMetricGrowth);
          this.secondaryMetricGroupId = this.generateMetricGroupId(this.secondaryMetricGroupId, this.useMetricGrowthForSecondary);
          this.display = true;
          this.getDetailedPredictiveAnalytics();
        }
      }
      this.display = true;
    },
    setAdditionalSecondaryMetrics(ids){
      // loop through the ids and set the selectedAdditionalSecondaryMetrics
      for (let i = 0; i < ids.length; i++) {
        let id = ids[i];
        let metric = this.additional_secondary_metric_options.find(metric => metric.value == id);
        if (typeof metric != "undefined") {
          this.selectedAdditionalSecondaryMetrics.push(metric);
        }
      }
    },
    processSavedChartCriteria(criteria) {
      let criteriaParameters = criteria.split("=");
      let defaultParameter = criteriaParameters[0];
      let defaultValue = criteriaParameters[1];
      let defaultCriteria = this.findCriteriaByParameter(defaultParameter);
      if (defaultParameter == "useMetricGrowth") {
          this.useMetricGrowth = criteriaParameters[1].toLowerCase() === "true";
      }
      if (defaultParameter == "useMetricGrowthForSecondary") {
          this.useMetricGrowthForSecondary = criteriaParameters[1].toLowerCase() === "true";
      }
      if (defaultParameter == "secondaryMetricGroupId") {
        this.secondaryMetricGroupId = defaultValue;
      }
      // Process Saved Survey Locations
      if (defaultParameter == "surveyLocation") {
        let savedSurveyLocations;
        try {
          savedSurveyLocations = JSON.parse(defaultValue);
        } catch (e) {
          var decodedSurveyLocations = decodeURIComponent(defaultValue).replace(/\+/g, " ");
          savedSurveyLocations = decodedSurveyLocations.split(',');
        }        
        this.surveyLocation = [...savedSurveyLocations];
      }
      // Process Saved Additional Secondary Metrics
      if (defaultParameter == "additionalSecondaryMetricIds") {
        let savedAdditionalSecondaryMetricIds;
        try {
          savedAdditionalSecondaryMetricIds = JSON.parse(defaultValue);
        } catch (e) {
          var decodedAdditionalSecondaryMetricIds = decodeURIComponent(defaultValue).replace(/\+/g, " ");
          savedAdditionalSecondaryMetricIds = decodedAdditionalSecondaryMetricIds.split(',');
        }        
        this.setAdditionalSecondaryMetrics(savedAdditionalSecondaryMetricIds);
      }
      if (defaultParameter == "words") {
       let savedWords;
        try {
          savedWords = JSON.parse(defaultValue);
        } catch (e) {
          var decodedSavedWords = decodeURIComponent(defaultValue).replace(/\+/g, " ");
           savedWords = decodedSavedWords.split(',');
        }        
        this.words = [...savedWords];
      }
      if (defaultParameter == "segments") {
        let currentSegments = this.segments;
        let savedSegments;
        try {
          savedSegments = JSON.parse(defaultValue);
        } catch (e) {
          var decodedDefaultValue = decodeURIComponent(defaultValue).replace(/\+/g, " ");
          savedSegments = $.parseJSON(decodedDefaultValue);
        }
        for (let currentSegmentsIndex = 0; currentSegmentsIndex < currentSegments.length; currentSegmentsIndex++) {
          let currentSegment = currentSegments[currentSegmentsIndex];
          for (let savedSegmentsIndex = 0; savedSegmentsIndex < savedSegments.length; savedSegmentsIndex++) {
            let savedSegment = savedSegments[savedSegmentsIndex];
            if (currentSegment.name == savedSegment.name) {
              currentSegment.values = savedSegment.values;
            }
          }
        }
      }      
      if (defaultParameter == "showLabels"){
        let showLabels = "";
        try {
          showLabels = JSON.parse(defaultValue);
        } catch (e) {
          showLabels = decodeURIComponent(defaultValue).replace(/\+/g, " ");
        }   
        this.eChartCriteria.showLabels = showLabels || (showLabels == "true");   
      }
      if (defaultParameter == "showTooltip"){
        let showTooltip = "";
        try {
          showTooltip = JSON.parse(defaultValue);
        } catch (e) {
          showTooltip = decodeURIComponent(defaultValue).replace(/\+/g, " ");
        }   
        this.eChartCriteria.showTooltip = showTooltip || (showTooltip == "true");   
      }
      if (typeof defaultCriteria != "undefined") {
        let isStartPeriod = defaultCriteria.parameterName == "startPeriod" ? true : false;
        let isEndPeriod = defaultCriteria.parameterName == "endPeriod" ? true : false;
        let isMetricGroupId = defaultCriteria.parameterName == "metricGroupId" ? true : false;
        let isSurveyGroup = defaultCriteria.parameterName == "survey_group" ? true : false;
        let isShowPublicGroups = defaultCriteria.parameterName == "show_public_groups" ? true : false;
        let isUseEqualWeight = defaultCriteria.parameterName == "use_equal_weight" ? true : false;   
        let isIncludePartialResponses = defaultCriteria.parameterName == "include_partial_responses" ? true : false;     
        let updateValue = isStartPeriod || isEndPeriod || isMetricGroupId;
        if (isStartPeriod) {
          this.startPeriod = parseInt(defaultValue);
        }
        if (isEndPeriod) {
          this.endPeriod = parseInt(defaultValue);
        }
        if (isMetricGroupId) {
          this.metricGroupId = defaultValue;
        }
        if (isUseEqualWeight) {
          this.useEqualWeight = defaultValue;
        }
        if (isIncludePartialResponses) {
          this.includePartialResponses = defaultValue;
        }
        if (isShowPublicGroups) {
          this.showPublicGroups = defaultValue;
          this.survey_group_options = this.getSurveyGroupOptions();
        }
        if (isSurveyGroup) {
          this.surveyGroup = defaultValue;
        }        
        this.saveResultValue(defaultValue, defaultCriteria.name, defaultCriteria.parameterName, updateValue);
      }
    },
    async getDetailedPredictiveAnalytics() {
      this.$root.processServerRequest("Retrieving data");
      this.setDisplayView(false);
      let params = this.buildClientChart(this.buildBaseCriteriaUrl);
      GoogleService.logGenerateChart(this.chart.title, "", this.survey.name, this.autoGenerateChartRun, this);
      ClientService.getDetailedPredictiveAnalytics(params, this.getDetailedPredictiveAnalyticsCallback, this);
    },
    buildBaseCriteriaUrl() {
      let params = new URLSearchParams();
      params.append("clientCode", ClientService.getClientCode());
      params.append("surveyId", SurveyService.getSurveyId());
      params.append("userId", UserService.getUserId());
      params.append("startPeriod", this.startPeriod);
      params.append("endPeriod", this.endPeriod);
      params.append("metricGroupId", this.parseMetricGroupId(this.metricGroupId,"primary"));
      params.append("secondaryMetricGroupId", this.parseMetricGroupId(this.secondaryMetricGroupId,"secondary"));
      params.append("additionalSecondaryMetricIds", this.selectedAdditionalSecondaryMetrics.map(({value}) => value));
      params.append("includePartialResponses", this.includePartialResponses);
      params.append("useMetricGrowth", this.useMetricGrowth);
      params.append("useMetricGrowthForSecondary", this.useMetricGrowthForSecondary);
      params.append("showLabels",this.eChartCriteria.showLabels);
      params.append("showTooltip",this.eChartCriteria.showTooltip);
      this.primaryMetric.metricGroupId = this.metricGroupId;
      this.secondaryMetric.metricGroupId = this.secondaryMetricGroupId;
      this.primaryMetric = this.setMetric(toRaw(this.primaryMetric));
      this.secondaryMetric = this.setMetric(toRaw(this.secondaryMetric));
      params.append("primaryMetric",JSON.stringify(this.primaryMetric));
      params.append("secondaryMetric",JSON.stringify(this.secondaryMetric));
      params.append("additionalSecondaryMetricsIds", this.additionalSecondaryMetricsIds);
      params.append("companyId", this.companyId);
      return this.buildCriteriaUrl(params);
    },
    generateMetricGroupId: function(inputMetricGroupId, inputUseMetricGrowth) {
      let returnMetricGroupId = inputMetricGroupId;
      if (inputUseMetricGrowth == true &&  !inputMetricGroupId.includes("growth")) {
        returnMetricGroupId = inputMetricGroupId+"-growth";
      }
      return returnMetricGroupId;
    },
    setMetric: function(metricObject){
      let inputMetricGroupId = metricObject.metricGroupId;
      if (inputMetricGroupId == "-1" || inputMetricGroupId == "0" || inputMetricGroupId == "") {
        return metricObject;
      }
      if (inputMetricGroupId.includes("growth")) {
        metricObject.useMetricGrowth = true;
        metricObject.metricGroupId = inputMetricGroupId.replace("-growth", "");
      } else {
        metricObject.useMetricGrowth = false;
      }
      return metricObject;
    },
    parseMetricGroupId: function(inputMetricGroupId,type) {
      if (inputMetricGroupId == "-1" || inputMetricGroupId == "0" || inputMetricGroupId == "") {
        return inputMetricGroupId;
      }
      if (inputMetricGroupId.includes("growth")) {
        if (type == "primary") {
          this.useMetricGrowth = true;
        } else {
          this.useMetricGrowthForSecondary = true;
        }
        inputMetricGroupId = inputMetricGroupId.replace("-growth", "");
      } else {
        if (type == "primary") {
          this.useMetricGrowth = false;
        } else {
          this.useMetricGrowthForSecondary = false;
        }
      }
      return inputMetricGroupId;
    },   
    saveProfileDataTable(){
      this.saveAllReportPages();
    }, 
    buildClientChartForPredictiveAnalytics: function(){
      this.buildClientChart(this.buildBaseCriteriaUrl);
      this.autoGenerateChartRun = false;
    },
    buildClientChart: function(buildURLFunction) {
      let useSaveParameters = typeof this.clientChart.criteria != undefined && this.clientChart.criteria != "" && this.autoGenerateChartRun;
      const params = useSaveParameters ? new URLSearchParams(this.clientChart.criteria) : buildURLFunction();
      this.clientChart.criteria = params.toString();
      this.clientChart.chartTypeId = this.embeddedInRoadmap ? 29 : this.chartType.chartTypeId;
      this.clientChart.clientId = this.clientId;
      this.clientChart.clientTimePeriodId = this.startPeriod;
      if (this.embeddedInRoadmap) {
        this.clientChart.displayType = "roadmap-predictive";
      } else if (typeof this.clientChart.displayType != "undefined" && typeof this.$refs.chartCriteria != "undefined") {
        this.clientChart.displayType = this.$refs.chartCriteria.$data.displayType;
      } else {
        this.clientChart.displayType = "analytics";
      }
      if (typeof this.saveClientChartObject.name == "undefined" || this.saveClientChartObject.name == "") {
        this.setDefaultClientChartName();
        this.clientChart.name = this.defaultClientChartName;
      }
      if (!this.displayChartOnly) {
        this.autoGenerateChartRun = false;
      }
      return params;
    },
    isNumber(value) {
      return value != "--";
    },
    getReportTableContentForPredictiveAnalytics(containerId) {
      let reportTableId = containerId + "_wrapper";
      return this.getReportTableContentByTable(reportTableId);
    },
    getRowData(inputRows){
      let rowData = [];
      let row = [];
      for (let inputRowindex = 0; inputRowindex < inputRows.length; inputRowindex++) {
        let inputRow = inputRows[inputRowindex];
        for (let index = 0; index < inputRow.length; index++) {
          row.push(inputRow[index].data);
        }
        rowData.push(row);
        row = [];
      }
      return rowData;
    },
    getMetricData(){
      let rowData = [];
      let row = [];
      for (let index = 0; index < this.metricsData.metricGrowthRow.length; index++) {
        row.push(this.metricsData.metricGrowthRow[index].data);
      }
      rowData.push(row);
      row = [];
      for (let index = 0; index < this.metricsData.metricRow.length; index++) {
        row.push(this.metricsData.metricRow[index].data);
      }
      rowData.push(row);

      if (this.displaySecondAxisOnTable && this.useMetricGrowthForSecondary){      
        row = [];
        for (let index = 0; index < this.metricsData.secondaryMetricGrowthRow.length; index++) {
          row.push(this.metricsData.secondaryMetricGrowthRow[index].data);
        }
        rowData.push(row);
      }

      if (this.displaySecondAxisOnTable && !this.useMetricGrowthForSecondary){      
        row = [];
        for (let index = 0; index < this.metricsData.secondaryMetricRow.length; index++) {
          row.push(this.metricsData.secondaryMetricRow[index].data);
        }
        rowData.push(row);
      }

      return rowData;
    },
    getColumnData(tableHeader){
      let columnData = [];
      for (let index = 0; index < tableHeader.length; index++) {
        columnData.push(tableHeader[index].data);
      }
      return columnData;
    },
    getTableData(rowData,columnData){
      let tableData = {
        rows: rowData,
        columns: columnData,
      }
      return JSON.stringify(tableData);
	  },    
    async saveReportPage(containerId, reportPageTableName) {
      if (this.clientChart.clientChartId != 0   && this.isGenerateReportRunning()) {
        let tableData;
        if (reportPageTableName == "Metric Trends"){
          let metricsRowData = this.getMetricData();
          let metricsColumnData = this.getColumnData(this.metricsData.tableHeader);
          tableData = this.getTableData(metricsRowData,metricsColumnData)

        } else if (reportPageTableName == "Predictive Analytics") {
          let predictiveAnalyticsRowData = this.predictiveAnalyticsTable.dataTable.rows().data().toArray();
          let predictiveAnalyticsColumnData = this.getColumnData(this.predictiveAnalyticsData.tableHeader);
          tableData = this.getTableData(predictiveAnalyticsRowData,predictiveAnalyticsColumnData)
        } else if (reportPageTableName == "Profile Trends") {
          let needsRowData = this.getRowData(this.needsData.rowsMap.rows);
          let needsColumnData = this.getColumnData(this.needsData.tableHeader);
          tableData = this.getTableData(needsRowData,needsColumnData)
        }
        await ReportService.saveReportTableFile(
          tableData,
          reportPageTableName,
          this.clientChart,
          this.saveReportTableFileCallback,
          this
        );
  
        await ReportService.saveReportPage(
          this.getReportTableContentForPredictiveAnalytics(containerId),
          reportPageTableName,
          this.clientChart,
          this.saveReportPageCallback,
          this
        );

      }
    },
    async saveAllReportPages() {
      await this.saveReportPage(this.metricsTableContainerId, "Metric Trends");
      await this.saveReportPage(this.analyticsTableContainerId, "Predictive Analytics");
      await this.saveReportPage(this.profileTableContainerId, "Profile Trends");
    },
    async saveContributionReportPages(){
      if (this.clientChart.clientChartId != 0   && this.isGenerateReportRunning()) {
          let containerId = 'p-contribution-snap-id';
          let reportPageName = 'Contribution';
          let reportPageChart = $("#" + containerId);
          let reportPageChartObject = reportPageChart[0];
          let imageReportPageChartContent = await this.createChartImage(reportPageChartObject, false, false);
          await ReportService.saveReportPage(imageReportPageChartContent, reportPageName, this.clientChart, this.saveReportPageCallback, this);          
          await ReportService.saveReportPageFile(this.imageUrl, "png", reportPageName, this.clientChart, this.saveReportPageCallback, this);
      }
    },
    getDetailedPredictiveAnalyticsCallback(response) {
      let tableTimeoutValue = 500;
      this.$root.processServerResponse(false);
      this.setDisplayView(true);
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.criteriaResultsList = AdminService.removeByName(response.data.data.criteriaList, "Competitor");
        this.chartTitle = "Metric Trends";
        this.displaySecondAxisOnTable = response.data.data.displaySecondAxisOnTable;
        this.metricsData = response.data.data.metricsData;
        this.predictiveAnalyticsData = response.data.data.predictiveAnalyticsData;
        this.needsData = response.data.data.needsData;
        let orderIndex = response.data.data.predictiveAnalyticsData.initialOrderIndex;
        this.correlationTypeId = response.data.data.correlationTypeId;
        let titleSuffix = response.data.data.titleSuffix;
        if (typeof titleSuffix != "undefined" && titleSuffix != null && titleSuffix != "") {
           this.titleSuffix = titleSuffix;
        }
        if (this.correlationTypeId == 2) {
          this.predictiveAnalyticsTable = MetricsService.getPredictiveTableAttributes("predictive-analytics-table","Negative");
          this.predictiveAnalyticsTable.configuration.order = [[orderIndex, "asc"]];
        } else {
          this.predictiveAnalyticsTable = MetricsService.getPredictiveTableAttributes("predictive-analytics-table","Positive");
          this.predictiveAnalyticsTable.configuration.order = [[orderIndex, "desc"]];
        }
        
        this.metricsTable.configuration.order = [[1, "asc"]];
        this.contributionChartList = [];
        let tempContributionChartList = JSON.parse(JSON.stringify(response.data.data.contributionChartList));
        this.contributionChartList = EChartsService.setContributionChartList(tempContributionChartList);
        
        let vm = this;
        setTimeout(() => {
          var tableSelector = "#" + vm.metricsTable.id;
          let isSavedCard = vm.clientChart.clientChartId != 0;
          if (!$.fn.DataTable.isDataTable(tableSelector) || typeof vm.metricsTable.dataTable == "undefined") {
            $.extend(vm.metricsTable.configuration, TableService.getTableButtons(this, "metrics-table", "metrics-table", "Metric Trends",isSavedCard, "Predictive Metric Trends"));
            vm.metricsTable.dataTable = $("#" + vm.metricsTable.id).DataTable(vm.metricsTable.configuration);
          }      

          let metricsTable = $("#" + vm.metricsTable.id);
          let html = "<div class='title pb-0'><h4 class='text-primary mb-0'>Metric Trends | " + vm.titleSuffix + "</h4></div>"
          metricsTable
            .parent()
            .find(".chart-header-container")
            .html(html);
          let metricsHeaderContainer = $("#metric-trends-data-container")
          .find(".metrics-table-header-container");

          if (metricsHeaderContainer.length > 1) {
            metricsHeaderContainer[0].remove();
          }         
          metricsTable.show();
          vm.saveReportPage(vm.metricsTableContainerId, "Metric Trends",vm.metricsTable.dataTable);
          tableSelector = "#" + vm.predictiveAnalyticsTable.id;
          if (!$.fn.DataTable.isDataTable(tableSelector) || typeof vm.predictiveAnalyticsTable.dataTable == "undefined") {            
            $.extend(
              vm.predictiveAnalyticsTable.configuration,
              TableService.getTableButtons(this, "predictive-analytics-table", "predictive-analytics-table", "Predictive Analytics",isSavedCard, "Predictive Analytics")
            );
            vm.predictiveAnalyticsTable.dataTable = $("#" + vm.predictiveAnalyticsTable.id).DataTable(vm.predictiveAnalyticsTable.configuration);
          }             
          vm.predictiveAnalyticsTable.dataTable.clear();
          for (let rowIndex = 0; rowIndex < vm.predictiveAnalyticsData.rowsMap.rows.length; rowIndex++) {
            let row = vm.predictiveAnalyticsData.rowsMap.rows[rowIndex];
            let filteredRow = [];
            for (let columnIndex = 0; columnIndex < row.length; columnIndex++) {
              let columnData = row[columnIndex].data;
              filteredRow.push(columnData);
            }
            vm.predictiveAnalyticsTable.dataTable.row.add(filteredRow);
          }
          vm.predictiveAnalyticsTable.dataTable.draw(true);

          let predictiveAnalyticsTable = $("#" + vm.predictiveAnalyticsTable.id);
          let tableTitleHtml = "<div class='title'><h4 class='text-primary mb-0'>Analytics | " + vm.titleSuffix + "</h4></div>";
          predictiveAnalyticsTable
            .parent()
            .find(".chart-header-container")
            .html(tableTitleHtml);
          let analyticsHeaderContainer = $("#analytics-data-container")
          .find(".predictive-analytics-table-header-container");

          if (analyticsHeaderContainer.length > 1) {
            analyticsHeaderContainer[0].remove();
          } 
          predictiveAnalyticsTable.show();
          vm.saveReportPage(vm.analyticsTableContainerId, "Predictive Analytics",vm.predictiveAnalyticsTable.dataTable);
          tableSelector = "#" + vm.needsTable.id;
          if (!$.fn.DataTable.isDataTable(tableSelector) || typeof vm.needsTable.dataTable == "undefined") {
            vm.needsTable.configuration.order = [
              [0, "desc"],
              [1, "asc"]
            ];
            $.extend(vm.needsTable.configuration, { orderFixed: [[0, "desc"]] });
            $.extend(vm.needsTable.configuration, TableService.getTableButtons(this, "needs-table", "needs-table", "Profile Trends",isSavedCard, "Predictive Profile Trends"));
            vm.needsTable.dataTable = $("#" + vm.needsTable.id).DataTable(vm.needsTable.configuration);
          }             
          tableTitleHtml = "<div class='title'><h4 class='text-primary mb-0'>Profile Trends | " + vm.titleSuffix + "</h4></div>";
          let needsTable = $("#" + vm.needsTable.id);
            needsTable
              .parent()
              .find(".chart-header-container")
              .html(tableTitleHtml);

          let needsHeaderContainer = $("#profile-trends-data-container")
          .find(".needs-table-header-container");

          if (needsHeaderContainer.length > 1) {
            needsHeaderContainer[0].remove();
          } 

          needsTable.show();
          vm.saveReportPage(vm.profileTableContainerId, "Profile Trends",vm.needsTable.dataTable);
          let useMetricGrowth = response.data.data.useMetricGrowth;
          let useMetricGrowthForSecondary = response.data.data.useMetricGrowthForSecondary;
          let copyOfData = JSON.parse(JSON.stringify(response.data));
          vm.parseForPredictiveAnalytics(copyOfData,useMetricGrowth,useMetricGrowthForSecondary);
          vm.$refs.eChart.processChart(true,"predictive-analytics",vm.eChartData,vm.eChartCriteria);
          setTimeout(() => {          
            vm.saveContributionReportPages();
          }, 500);
          
        }, tableTimeoutValue);
        setTimeout(() => {
          vm.generateNextClientChartLink();
        }, 6000);
      } else if (statusCode == 201) {
        AdminService.displaySuccessMessage({ text: response.data.message, duration: -1 },true);
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    parseForPredictiveAnalytics:function(inputData,useMetricGrowth,useMetricGrowthForSecondary){
      let itemsToRemove = {
          lastColumns: 0,
          firstRows: 1,
          firstColumns: 0
        };
      let data = {};
      let chart1Data = inputData;
      data = PredictiveAnalyticsService.parseData(1,chart1Data,data,itemsToRemove,useMetricGrowth,useMetricGrowthForSecondary);
      data = PredictiveAnalyticsService.parseLegendAndColorData(chart1Data,data);
      this.eChartData = JSON.parse(JSON.stringify(data));
    },    
    async getChartCriteriaOptionsCallback(response) {
      this.$root.processServerResponse(false);
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.correlationTypeId = response.data.data.correlationTypeId;
        this.metricGroupId = response.data.data.metricGroupId;
        this.baseMetricGroupId = response.data.data.metricGroupId;
        this.secondaryMetricGroupId = response.data.data.secondaryMetricGroupId;
        if (typeof response.data.data.startTimePeriod != "undefined") {
          this.startPeriod = response.data.data.startTimePeriod;
          this.basePeriod = response.data.data.startTimePeriod;
        }
        if (typeof response.data.data.endTimePeriod != "undefined") {
          this.endPeriod = response.data.data.endTimePeriod;
          this.basePeriod = response.data.data.startTimePeriod;
        }
        this.period_options = response.data.data.clientTimePeriods;
        let additionalOptions = response.data.data.additionalOptions;
        this.criteriaResults = [];
        for (var i in additionalOptions) {
          this.criteriaResults.push(additionalOptions[i]);
        }
        this.surveyGroupList = response.data.data.surveyGroupList;
        this.segments = ChartService.getSegments(this.criteriaResults);
        this.survey_group_options = this.getSurveyGroupOptions();
        await ClientCompetitorService.getCompetitors(this.clientId, this.startPeriod, false, this.loadCompetitors);      
        await ClientCompetitorService.getCompetitorCompanies(this.clientId, SurveyService.getSurveyId(), this.loadCompetitors);
        this.processAutoGenerateChart();
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    getMetricGroupByClientIdCallback(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        MetricsService.setMetricDropdownOptions(response.data.data,this, true);
        this.disableGenerate = false;
      } else if (statusCode == 201) {
        this.disableGenerate = false;
        AdminService.displaySuccessMessage({ text: response.data.message, duration: -1 },true);
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    async initializeData() {
      this.display = false;
      this.setDisplayView(false);
      if (!this.autoGenerateChartRun) {
        this.criteriaResults = [];
        this.resetChartCriteria(false);
      }
      this.clearTable();
      await MetricsService.getMetricGroupBySurveyCodeWithCompetitors(SurveyService.getSurveyCode(), this.getMetricGroupByClientIdCallback, this);
      await ClientService.getPredictiveAnalyticsOptions(this.getChartCriteriaOptionsCallback, this);
      this.setUseEqualWeight();
    },
    loadCompetitors(data) {
      this.company_options = [];
      for (var i = 0; i < data.length; i++) {
        this.company_options.push({ value: data[i].clientCompetitorsId, name: data[i].name });
      }
    },
    async getPageContent(pageName) {
      ContentService.getPageContent(pageName, this.getPageContentCallBack, this);
    },    
    getPageContentCallBack(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.pageContent = [...this.pageContent, ...response.data.data];
      }
    },
    setShowTooltip(inputShowTooltip){
      this.eChartCriteria.showTooltip = inputShowTooltip;
      this.$refs.eChart.processChart(true,"predictive-analytics", this.eChartData, this.eChartCriteria);
    },
    setShowLabels(inputShowLabels){
      this.eChartCriteria.showLabels = inputShowLabels;
      this.$refs.eChart.processChart(true,"predictive-analytics", this.eChartData, this.eChartCriteria);
    },
    getDefaultEChartCriteria: function(){
      return EChartsService.getBaseEChartCriteria();
    },
    removeAdditionalSecondaryMetricByValue(value) {
      var match = this.selectedAdditionalSecondaryMetrics.find(x => x.value == value);
      if (typeof match !== "undefined") {
        this.selectedAdditionalSecondaryMetrics.splice($.inArray(match, this.selectedAdditionalSecondaryMetrics), 1);
      }  
    },
    removeAdditionalSecondaryMetric(selectedMetric) {
      if (typeof selectedMetric !== "undefined") {
        selectedMetric.checked = false;
      }       
    },
    addAdditionalSecondaryMetric(id) {
      id.checked = true;
    },
    returnMetricTableRows: function(){
      if (typeof this.metricsData.returnMetricsList != "undefined" && this.metricsData.returnMetricsList.length > 0){
        let returnMetricsList = JSON.parse(JSON.stringify(this.metricsData.returnMetricsList));
        returnMetricsList = returnMetricsList.sort((a, b) => a.year - b.year);
        let finalReturnMetricsList = returnMetricsList.map(({metricRow}) => metricRow);
        return finalReturnMetricsList;
      }
      return [];
    },
    getWordCountsCallback:function(response){},
    redirectMigratedRoadmapPredictiveCard() {
      if (this.embeddedInRoadmap || this.saveClientChartId <= 0 || !["predictive-analytics", "predictive-analytics-default"].includes(this.$route.name)) {
        return;
      }
      const savedCard = this.clientChartsBySurvey.find(card => card.clientChartId == this.saveClientChartId);
      if (savedCard != null && savedCard.chartTypeId == 29 && savedCard.displayType == "roadmap-predictive") {
        this.$router.replace({
          name: "value-roadmap",
          params: { autoGenerateChart: true, saveClientChartId: savedCard.clientChartId }
        });
      }
    }
  },
  created() {
    this.initializeData();
  },
  mounted() {
    this.metricsTable.configuration.order = [[1, "asc"]];
    this.getPageContent("Chart");
    this.redirectMigratedRoadmapPredictiveCard();
  },
  watch: {
    clientChartsBySurvey: function() {
      this.redirectMigratedRoadmapPredictiveCard();
    },
    saveClientChartId: function() {
      if (this.saveClientChartId > 0) {
        this.processClientChart();
        this.initializeData();
      }
    },
    async surveyCode() {
      this.initializeData();
    },
/*    
    async endPeriod(){
      await WordCloudService.getWordCounts(SurveyService.getSurveyId(), this.endPeriod, true, this.getWordCountsCallback);
    },
*/    
  },
  computed: {
    isPositiveCorrelation: function() {
      let inputSecondaryMetricGroupId = String(this.secondaryMetricGroupId ?? "-1");
      let inputMetricGroupId = String(this.metricGroupId ?? "0");
      if (inputMetricGroupId.includes("growth")) {
        inputMetricGroupId = inputMetricGroupId.replace("-growth", "");
      }      
      if (inputSecondaryMetricGroupId.includes("growth")) {
        inputSecondaryMetricGroupId = inputSecondaryMetricGroupId.replace("-growth", "");
      }
      let secondaryMetricGroup = this.metric_options.find(metricGroup => Number(metricGroup.value) == Number(inputSecondaryMetricGroupId));
      if (typeof secondaryMetricGroup != "undefined") {
        return secondaryMetricGroup.correlationTypeName == "Positive";
      }
      let currenMetricGroup = this.metric_options.find(metricGroup => Number(metricGroup.value) == Number(inputMetricGroupId));
      if (typeof currenMetricGroup != "undefined") {
        return currenMetricGroup.correlationTypeName == "Positive";
      }
      return true;
    },
    disableSecondaryAxisAdditionalMetricDropdown: function() {
      return this.secondaryMetricGroupId == "-1";
    },
    primary_metric_options: function() {
      if (Number(this.companyId) != 0){
        return this.metric_options.filter(metricGroup => metricGroup.clientCompetitorsId == Number(this.companyId));
      } 
      return this.metric_options.filter(metricGroup => metricGroup.clientCompetitorsId == null);
    },
    secondary_metric_options: function() {
      return this.primary_metric_options.filter(metricGroup => metricGroup.value != this.metricGroupId);
    },
    additional_secondary_metric_options: function() {
      return this.primary_metric_options.filter(metricGroup => (metricGroup.value != this.metricGroupId && metricGroup.value != this.secondaryMetricGroupId));
      
    },
    additionalSecondaryMetricsIds: function() {
      return this.selectedAdditionalSecondaryMetrics.map(({value}) => value);
    },
    clientName: function() {
      return this.clientObject.name;
    },
    displayChartOnly: function() {
      return this.secondaryMetricGroupId != "-1";
    },
    metricGroupName: function() {
      let currenMetricGroup = this.primary_metric_options.find(metricGroup => metricGroup.value == this.value);
      if (typeof currenMetricGroup != "undefined") {
        return currenMetricGroup.name;
      }
      return "";
    }
  }
};
</script>
